import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
//import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';
import { ValidatorService } from '../../services/validator/validator.service';

import { Choice } from './choice';

import { RadiobuttonRoutingModule } from './radiobutton.routing.module';

const errorMessage: any = {
  required: 'Ce champ est requis'
};

@Component({
  selector: 'radiobutton',
  template: `
  <div class="md-form form-sm form-inline" *ngIf="form.controls[name]" [formGroup]="form" [ngClass]="{'has-error':error}" [ngStyle]="{'border-bottom: ': (error ? '1px solid #F44336;' :'')}">
    <i *ngIf="glyph" class="{{glyph}} prefix" [ngClass]="{'active':control.value>111}"></i>
    <fieldset *ngIf="choices.length == 0" class="form-group"><input type="text" value="No choice" readonly></fieldset>
    <fieldset *ngFor="let choice of choices" class="form-group">
      <input type="radio" style="margin-bottom: 0px;" id="{{choice.id}}" [checked]="choice.id == value" value="choice.value" (click)="selectChoice(choice.id)">
      <label [attr.for]="choice.id">{{choice.value}}</label>
    </fieldset>
    <label *ngIf="caption" [attr.for]="name" class="active"><em *ngIf="readonly">{{caption}}</em><b *ngIf="!readonly">{{caption}}</b><span *ngIf="required && !(control?.value > 111)" style="color: red;"><b> *</b></span></label>
  </div>
  <span *ngIf="error" class="help-block text-danger" [ngStyle]="{'padding-left': (glyph ? '34px' :'')}" style="font-size: 15px"><b>{{ error }}</b></span>`,
  styles: [`
    .md-form .prefix ~ fieldset {
      margin-left: 2.2rem;
      display: inline-block;
  }
  .md-form, .md-form .btn {
      margin-bottom: 1.5rem;
  }
  [type="radio"]:checked + label, [type="radio"]:not(:checked) + label {
      padding-left: 30px !important;
      margin-bottom: 20px;
  }`],
  encapsulation: ViewEncapsulation.None
})

export class RadiobuttonComponent implements OnInit {
  @Input() public name: string = '';
  @Input() public caption: string = '';
  public readonly: boolean = false;
  @Input() public control: AbstractControl;
  @Input() public enabled: Boolean = false;
  @Input() public value: number;
  @Input() public glyph: string = '';
  @Input() public form: FormGroup;
  @Input() public error: any;
  @Input() public _required: boolean = false;
  @Input() public visible: boolean = true;
  @Input() public showEmpty: Boolean = false;
  @Input() public restName: string = '';
  @Input() public fieldName: string = '';
  @Input() public choices: Choice[] = new Array<Choice>();
  @Input() public items: any[] = new Array<any>();

  constructor(
    public itemService: GenericdatasetService, public validatorService: ValidatorService) {
  }

  ngOnInit(): void {
    this.initialize();
    this.itemService.setrestName(this.restName);
    this.itemService.getItems(1, 0, '', new Array<any>(), '')
      .subscribe(
      (items) => this.items = items,
      (error) => {
        this.error = error;
      },
      () => {
        for (let i = 0; i <= this.items.length - 1; i++) {
          if ((this.showEmpty && !this.items[i][this.fieldName]) || (this.items[i][this.fieldName])) {
            const choice: Choice = new Choice();
            choice.id = this.items[i]['id'];
            choice.value = this.items[i][this.fieldName];
            choice.checked = (choice.id == this.value);
            this.choices.push(choice);
          }
        }
      });
    this.control.valueChanges.subscribe((value) => {
      this.returnError();
    });
  }

  initialize() {
    if (!this.control) {
      if (this.form.controls[this.name] == null) {
        this.control = new FormControl();
        this.form.addControl(this.name, this.control);
      }
      this.control = this.form.controls[this.name];
    }    
    this.required = this._required;
  }

  @Input() public set required(required: boolean) {
    if (required && this.control) {
      this.control.setValidators(this.validatorService.isRequire);
    } else if (this.control) {
      this.control.clearValidators();
    }
    this._required = required;
  }

  public get required() {
    return this._required;
  }

  setValue(choices: Choice[]): void {
    this.choices = choices;
  }

  getValue(choices: Choice[]): Choice[] {
    return this.choices;
  }

  selectChoice(id: number): void {
    const choices: Choice[] = this.choices.filter(function (value) {
      return value.id == id;
    });
    let selectedChoice: number = 0;
    if (choices) {
      selectedChoice = choices[0].id;
    }
    this.value = selectedChoice;
    this.form.controls[this.name].patchValue(this.value);
  }

  returnError() {
    this.error = '';
    if (this.control && !this.control.valid && this.control.errors) {
      for (const key in this.control.errors) {
        if (key in errorMessage) {
          this.error += errorMessage[key] + ' ';
        }
      }
    }
  }
}
